// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fieldBlock__aRxHk {
  width: 100%;
}

.labelField__lvdT7 {
  display: flex;
  gap: 5px;
}

.infoIcon__z0dGO {
  width: 14px;
  height: 14px;
  margin-top: -2px;
}

.datepickerWrapper__vikza {
  position: relative;
}

.datepicker__y9Cqt {
  font-size: 12px;
  line-height: 20px;
  color: var(--inputs-filled-text);
  width: 100%;
  padding: 7px 12px 6px;
  border: 1px solid var(--inputs-default-stroke);
  border-radius: 5px;
}
.datepicker__y9Cqt:focus, .datepicker__y9Cqt:active {
  border-color: var(--calendar-text-icon-selected);
  outline: none !important;
}
.datepicker__y9Cqt:disabled {
  border-color: var(--inputs-disable-stroke);
  color: var(--inputs-disable-text);
}

.datepickerFilled__KUh6G {
  border: 1px solid var(--inputs-filled-stroke);
}

.datePickerHeader__GzFx8 {
  width: 100%;
  height: 35px;
  display: flex;
  justify-content: space-between;
  background: var(--calendar-surface-title);
}

.dropdownsContainer__Ph4fF {
  display: flex;
  justify-content: center;
  align-items: center;
}

.customDropdown__AMaRp {
  position: relative;
  max-width: 100px;
  min-width: 80px;
  color: var(--calendar-text-icon-default);
}

.customDropdownHeader__jH77H {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 10px;
  text-transform: uppercase;
  cursor: pointer;
}

.customDropdownIcon__l5T8b {
  width: 20px;
  height: 20px;
}

.customDropdownMenu__IaRZL {
  position: absolute;
  max-height: 218px;
  overflow-y: scroll;
  overflow-x: unset;
  max-width: 100px;
  min-width: 80px;
  top: 100%;
  left: 0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 10;
}
.customDropdownMenu__IaRZL::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.customDropdownMenu__IaRZL::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.customDropdownMenu__IaRZL::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.customDropdownMenu__IaRZL::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.customDropdownItem__WT_pJ {
  text-align: start;
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--calendar-surface-row);
}
.customDropdownItem__WT_pJ:hover {
  background: var(--calendar-day-selected);
  color: var(--calendar-text-icon-selected);
}

.prevMonthButton__L4oNE,
.nextMonthButton__dhEO5 {
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.prevMonthButton__L4oNE path,
.nextMonthButton__dhEO5 path {
  stroke: var(--calendar-text-icon-default);
}
.prevMonthButton__L4oNE.buttonDisabled__fDFF0,
.nextMonthButton__dhEO5.buttonDisabled__fDFF0 {
  pointer-events: none;
}
.prevMonthButton__L4oNE.buttonDisabled__fDFF0 path,
.nextMonthButton__dhEO5.buttonDisabled__fDFF0 path {
  stroke: var(--calendar-text-icon-disable);
}
.prevMonthButton__L4oNE:hover,
.nextMonthButton__dhEO5:hover {
  background: var(--calendar-day-selected);
}
.prevMonthButton__L4oNE:hover path,
.nextMonthButton__dhEO5:hover path {
  stroke: var(--calendar-text-icon-selected);
}

.nextMonthButton__dhEO5 {
  transform: rotateY(180deg);
}

.react-datepicker-wrapper {
  width: 100%;
}
.react-datepicker-popper[data-placement^=bottom] {
  padding: 0;
}
.react-datepicker__view-calendar-icon input {
  padding: 7px 15px;
  border-radius: 2px;
  background: var(--inputs-default-surface-default);
}
.react-datepicker__view-calendar-icon input::placeholder {
  color: var(--inputs-default-placeholder);
}
.react-datepicker__calendar-icon {
  width: 16px;
  height: 16px;
}
.react-datepicker__input-container .react-datepicker__calendar-icon {
  padding: unset;
}
.react-datepicker {
  border-radius: 0;
  border: none;
  box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);
  background: var(--calendar-surface-title);
}
.react-datepicker .react-datepicker__triangle {
  display: none;
}
.react-datepicker .react-datepicker__month-container {
  width: 290px;
}
.react-datepicker .react-datepicker__header {
  padding: 0;
}
.react-datepicker .react-datepicker__day-names {
  margin: 0;
  height: 40px;
  display: flex;
  justify-content: space-between;
  background: var(--calendar-surface-title);
  border-bottom: 1px solid var(--calendar-stroke);
  border-top: 1px solid var(--calendar-stroke);
}
.react-datepicker .react-datepicker__day-names .react-datepicker__day-name {
  width: 40px;
  height: 40px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  color: var(--calendar-text-icon-default);
  font-weight: 500;
}
.react-datepicker .react-datepicker__current-month {
  display: none;
}
.react-datepicker .react-datepicker__navigation {
  height: 35px;
  width: 35px;
}
.react-datepicker .react-datepicker__navigation-icon::before {
  width: 6px;
  height: 6px;
  border-color: var(--calendar-text-icon-default);
}
.react-datepicker .react-datepicker__navigation-icon--previous, .react-datepicker .react-datepicker__navigation--previous, .react-datepicker .react-datepicker__navigation-icon--next {
  top: 0;
  right: 0;
  left: 0;
}
.react-datepicker .react-datepicker__navigation--next {
  top: 0;
  right: 0;
}
.react-datepicker .react-datepicker__navigation-icon {
  top: 0;
}
.react-datepicker .react-datepicker__navigation:hover {
  border-radius: 0.3rem;
  background: var(--calendar-day-selected);
}
.react-datepicker .react-datepicker__month, .react-datepicker .react-datepicker__day {
  margin: 0;
}
.react-datepicker .react-datepicker__week {
  display: flex;
}
.react-datepicker .react-datepicker__day {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  width: 42px;
  height: 36px;
  color: var(--calendar-text-icon-default);
  outline: none;
}
.react-datepicker .react-datepicker__day--outside-month, .react-datepicker .react-datepicker__day--disabled {
  color: var(--calendar-text-icon-disable);
}
.react-datepicker .react-datepicker__day--keyboard-selected.react-datepicker__day--today {
  background: none;
}
.react-datepicker .react-datepicker__day--today {
  font-weight: 500;
  color: var(--calendar-text-icon-selected);
  position: relative;
}
.react-datepicker .react-datepicker__day--today::after {
  content: "";
  width: 4px;
  height: 4px;
  position: absolute;
  background: var(--calendar-text-icon-selected);
  border-radius: 50%;
  top: 27px;
}
.react-datepicker .react-datepicker__day:hover, .react-datepicker .react-datepicker__day--keyboard-selected, .react-datepicker .react-datepicker__day--in-selecting-range, .react-datepicker .react-datepicker__day--in-range, .react-datepicker .react-datepicker__day--selected {
  font-weight: 500;
  border-radius: 0;
  background: var(--calendar-day-selected);
  color: var(--calendar-text-icon-selected);
}
.react-datepicker .react-datepicker__time-container {
  box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);
  position: absolute;
  left: 100%;
  margin-left: 5px;
  border: none;
}
.react-datepicker .react-datepicker-time__header {
  color: var(--calendar-text-icon-default);
  letter-spacing: 0.5px;
  font-size: 12px;
  font-weight: 500;
  padding: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: var(--calendar-surface-title);
  width: 100%;
  height: 35px;
}
.react-datepicker .react-datepicker__time-list {
  overflow-y: auto !important;
}
.react-datepicker .react-datepicker__time-list::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.react-datepicker .react-datepicker__time-list::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.react-datepicker .react-datepicker__time-list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.react-datepicker .react-datepicker__time-list::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
.react-datepicker .react-datepicker__time {
  background: var(--calendar-surface-title);
}
.react-datepicker .react-datepicker__time-list-item {
  color: var(--calendar-text-icon-default);
  background: var(--calendar-surface-row);
  height: unset !important;
  padding: 10px !important;
  display: flex;
  justify-content: flex-start;
}
.react-datepicker .react-datepicker__time-list-item--selected, .react-datepicker .react-datepicker__time-list-item:not(.react-datepicker__time-list-item--disabled):hover {
  background: var(--calendar-day-selected) !important;
  color: var(--calendar-text-icon-selected) !important;
}
.react-datepicker .react-datepicker__time-list-item.react-datepicker__time-list-item--disabled:hover {
  background: var(--calendar-surface-row) !important;
}

.injectedTimes__xhpoU .react-datepicker__time-list-item:not(.react-datepicker__time-list-item--injected) {
  display: none !important;
}

.label___lp_b {
  display: block;
  margin-bottom: 4px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  text-transform: uppercase;
}

.required__vS2TB:after {
  content: "*";
  font-size: 10px;
  line-height: 12px;
  color: var(--inputs-error-stroke);
  margin-left: 4px;
}

.calendarIcon__lkjfb {
  position: absolute;
  bottom: 10px;
  right: 13px;
}

.helperText__rf2VP {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: var(--inputs-error-stroke);
  margin-top: 4px;
  min-height: 11px;
}
@media (max-width: 850px) {
  .helperText__rf2VP {
    font-size: 8px;
    line-height: 8px;
    margin-top: 2px;
    min-height: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/components/form/DatePicker/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,QAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,kBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,WAAA;EACA,qBAAA;EACA,8CAAA;EACA,kBAAA;AAzEF;AA2EE;EAEE,gDAAA;EACA,wBAAA;AA1EJ;AA6EE;EACE,0CAAA;EACA,iCAAA;AA3EJ;;AA+EA;EACE,6CAAA;AA5EF;;AA+EA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,yCAAA;AA5EF;;AA+EA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AA5EF;;AA+EA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,wCAAA;AA5EF;;AA+EA;EACE,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,eAAA;AA5EF;;AA+EA;EACE,WAAA;EACA,YAAA;AA5EF;;AA+EA;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,OAAA;EACA,wCAAA;EACA,WAAA;AA5EF;AA7DE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AA+DJ;AA5DE;EACE,+BAAA;EACA,kBAAA;AA8DJ;AA3DE;EACE,8BAAA;EACA,kBAAA;AA6DJ;AA1DE;EACE,gBAAA;EACA,kBAAA;AA4DJ;;AAgEA;EACE,iBAAA;EACA,aAAA;EACA,eAAA;EACA,yDAAA;EACA,uCAAA;AA7DF;AA+DE;EACE,wCAAA;EACA,yCAAA;AA7DJ;;AAiEA;;EAEE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA9DF;AAgEE;;EACE,yCAAA;AA7DJ;AAgEE;;EACE,oBAAA;AA7DJ;AA+DI;;EACE,yCAAA;AA5DN;AAgEE;;EACE,wCAAA;AA7DJ;AA8DI;;EACE,0CAAA;AA3DN;;AAgEA;EACE,0BAAA;AA7DF;;AAiEE;EACE,WAAA;AA9DJ;AAgEE;EACE,UAAA;AA9DJ;AAiEE;EACE,iBAAA;EACA,kBAAA;EACA,iDAAA;AA/DJ;AAkEE;EACE,wCAAA;AAhEJ;AAmEE;EACE,WAAA;EACA,YAAA;AAjEJ;AAoEE;EACE,cAAA;AAlEJ;AAqEE;EACE,gBAAA;EACA,YAAA;EACA,2FACE;EAEF,yCAAA;AArEJ;AAuEI;EACE,aAAA;AArEN;AAwEI;EACE,YAAA;AAtEN;AAwEI;EACE,UAAA;AAtEN;AA0EI;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,yCAAA;EACA,+CAAA;EACA,4CAAA;AAxEN;AA0EM;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,wCAAA;EACA,gBAAA;AAxER;AA4EI;EACE,aAAA;AA1EN;AA6EI;EACE,YAAA;EACA,WAAA;AA3EN;AA6EI;EACE,UAAA;EACA,WAAA;EACA,+CAAA;AA3EN;AA8EI;EAGE,MAAA;EACA,QAAA;EACA,OAAA;AA5EN;AA8EI;EACE,MAAA;EACA,QAAA;AA5EN;AA+EI;EACE,MAAA;AA7EN;AAgFI;EACE,qBAAA;EAEA,wCAAA;AA/EN;AAkFI;EAEE,SAAA;AAhFN;AAmFI;EACE,aAAA;AAjFN;AAoFI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;EACA,aAAA;AAlFN;AAqFI;EAEE,wCAAA;AAnFN;AAsFI;EACE,gBAAA;AApFN;AAsFI;EACE,gBAAA;EACA,yCAAA;EACA,kBAAA;AApFN;AAuFI;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,8CAAA;EACA,kBAAA;EACA,SAAA;AArFN;AAwFI;EAKE,gBAAA;EACA,gBAAA;EACA,wCAAA;EACA,yCAAA;AAtFN;AA0FI;EACE,2FACE;EAEF,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;AA1FN;AA6FI;EACE,wCAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,yCAAA;EACA,WAAA;EACA,YAAA;AA3FN;AA8FI;EACE,2BAAA;AA5FN;AAzRE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AA2RJ;AAxRE;EACE,+BAAA;EACA,kBAAA;AA0RJ;AAvRE;EACE,8BAAA;EACA,kBAAA;AAyRJ;AAtRE;EACE,gBAAA;EACA,kBAAA;AAwRJ;AA+EI;EACE,yCAAA;AA7EN;AAgFI;EACE,wCAAA;EACA,uCAAA;EACA,wBAAA;EACA,wBAAA;EACA,aAAA;EACA,2BAAA;AA9EN;AAgFM;EAEE,mDAAA;EACA,oDAAA;AA/ER;AAkFM;EACE,kDAAA;AAhFR;;AAyFM;EACE,wBAAA;AAtFR;;AA4FA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAzFF;;AA6FE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,gBAAA;AA1FJ;;AA8FA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AA3FF;;AA8FA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;AA3FF;AA6FE;EARF;IASI,cAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;EA1FF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.fieldBlock {\n  width: 100%;\n}\n\n.labelField {\n  display: flex;\n  gap: 5px;\n}\n\n.infoIcon {\n  width: 14px;\n  height: 14px;\n  margin-top: -2px;\n}\n\n.datepickerWrapper {\n  position: relative;\n}\n\n.datepicker {\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--inputs-filled-text);\n  width: 100%;\n  padding: 7px 12px 6px;\n  border: 1px solid var(--inputs-default-stroke);\n  border-radius: 5px;\n\n  &:focus,\n  &:active {\n    border-color: var(--calendar-text-icon-selected);\n    outline: none !important;\n  }\n\n  &:disabled {\n    border-color: var(--inputs-disable-stroke);\n    color: var(--inputs-disable-text);\n  }\n}\n\n.datepickerFilled {\n  border: 1px solid var(--inputs-filled-stroke);\n}\n\n.datePickerHeader {\n  width: 100%;\n  height: 35px;\n  display: flex;\n  justify-content: space-between;\n  background: var(--calendar-surface-title);\n}\n\n.dropdownsContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.customDropdown {\n  position: relative;\n  max-width: 100px;\n  min-width: 80px;\n  color: var(--calendar-text-icon-default);\n}\n\n.customDropdownHeader {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  padding: 10px;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.customDropdownIcon {\n  width: 20px;\n  height: 20px;\n}\n\n.customDropdownMenu {\n  position: absolute;\n  max-height: 218px;\n  overflow-y: scroll;\n  overflow-x: unset;\n  max-width: 100px;\n  min-width: 80px;\n  top: 100%;\n  left: 0;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n\n  @include scrollBar;\n}\n\n.customDropdownItem {\n  text-align: start;\n  padding: 10px;\n  cursor: pointer;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n  background: var(--calendar-surface-row);\n\n  &:hover {\n    background: var(--calendar-day-selected);\n    color: var(--calendar-text-icon-selected);\n  }\n}\n\n.prevMonthButton,\n.nextMonthButton {\n  width: 35px;\n  height: 35px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  path {\n    stroke: var(--calendar-text-icon-default);\n  }\n\n  &.buttonDisabled {\n    pointer-events: none;\n\n    path {\n      stroke: var(--calendar-text-icon-disable);\n    }\n  }\n\n  &:hover {\n    background: var(--calendar-day-selected);\n    path {\n      stroke: var(--calendar-text-icon-selected);\n    }\n  }\n}\n\n.nextMonthButton {\n  transform: rotateY(180deg);\n}\n\n:global {\n  .react-datepicker-wrapper {\n    width: 100%;\n  }\n  .react-datepicker-popper[data-placement^='bottom'] {\n    padding: 0;\n  }\n\n  .react-datepicker__view-calendar-icon input {\n    padding: 7px 15px;\n    border-radius: 2px;\n    background: var(--inputs-default-surface-default);\n  }\n\n  .react-datepicker__view-calendar-icon input::placeholder {\n    color: var(--inputs-default-placeholder);\n  }\n\n  .react-datepicker__calendar-icon {\n    width: 16px;\n    height: 16px;\n  }\n\n  .react-datepicker__input-container .react-datepicker__calendar-icon {\n    padding: unset;\n  }\n\n  .react-datepicker {\n    border-radius: 0;\n    border: none;\n    box-shadow:\n      0px 0px 1px 0px rgba(12, 26, 75, 0.24),\n      0px 3px 8px -1px rgba(50, 50, 71, 0.05);\n    background: var(--calendar-surface-title);\n\n    .react-datepicker__triangle {\n      display: none;\n    }\n\n    .react-datepicker__month-container {\n      width: 290px;\n    }\n    .react-datepicker__header {\n      padding: 0;\n    }\n\n    //days\n    .react-datepicker__day-names {\n      margin: 0;\n      height: 40px;\n      display: flex;\n      justify-content: space-between;\n      background: var(--calendar-surface-title);\n      border-bottom: 1px solid var(--calendar-stroke);\n      border-top: 1px solid var(--calendar-stroke);\n\n      .react-datepicker__day-name {\n        width: 40px;\n        height: 40px;\n        margin: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        text-transform: uppercase;\n        color: var(--calendar-text-icon-default);\n        font-weight: 500;\n      }\n    }\n\n    .react-datepicker__current-month {\n      display: none;\n    }\n\n    .react-datepicker__navigation {\n      height: 35px;\n      width: 35px;\n    }\n    .react-datepicker__navigation-icon::before {\n      width: 6px;\n      height: 6px;\n      border-color: var(--calendar-text-icon-default);\n    }\n\n    .react-datepicker__navigation-icon--previous,\n    .react-datepicker__navigation--previous,\n    .react-datepicker__navigation-icon--next {\n      top: 0;\n      right: 0;\n      left: 0;\n    }\n    .react-datepicker__navigation--next {\n      top: 0;\n      right: 0;\n    }\n\n    .react-datepicker__navigation-icon {\n      top: 0;\n    }\n\n    .react-datepicker__navigation:hover {\n      border-radius: 0.3rem;\n\n      background: var(--calendar-day-selected);\n    }\n\n    .react-datepicker__month,\n    .react-datepicker__day {\n      margin: 0;\n    }\n\n    .react-datepicker__week {\n      display: flex;\n    }\n\n    .react-datepicker__day {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin: 0;\n      width: 42px;\n      height: 36px;\n      color: var(--calendar-text-icon-default);\n      outline: none;\n    }\n\n    .react-datepicker__day--outside-month,\n    .react-datepicker__day--disabled {\n      color: var(--calendar-text-icon-disable);\n    }\n\n    .react-datepicker__day--keyboard-selected.react-datepicker__day--today {\n      background: none;\n    }\n    .react-datepicker__day--today {\n      font-weight: 500;\n      color: var(--calendar-text-icon-selected);\n      position: relative;\n    }\n\n    .react-datepicker__day--today::after {\n      content: '';\n      width: 4px;\n      height: 4px;\n      position: absolute;\n      background: var(--calendar-text-icon-selected);\n      border-radius: 50%;\n      top: 27px;\n    }\n\n    .react-datepicker__day:hover,\n    .react-datepicker__day--keyboard-selected,\n    .react-datepicker__day--in-selecting-range,\n    .react-datepicker__day--in-range,\n    .react-datepicker__day--selected {\n      font-weight: 500;\n      border-radius: 0;\n      background: var(--calendar-day-selected);\n      color: var(--calendar-text-icon-selected);\n    }\n\n    // TIME SELECT\n    .react-datepicker__time-container {\n      box-shadow:\n        0px 0px 1px 0px rgba(12, 26, 75, 0.24),\n        0px 3px 8px -1px rgba(50, 50, 71, 0.05);\n      position: absolute;\n      left: 100%;\n      margin-left: 5px;\n      border: none;\n    }\n\n    .react-datepicker-time__header {\n      color: var(--calendar-text-icon-default);\n      letter-spacing: 0.5px;\n      font-size: 12px;\n      font-weight: 500;\n      padding: 10px;\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      background: var(--calendar-surface-title);\n      width: 100%;\n      height: 35px;\n    }\n\n    .react-datepicker__time-list {\n      overflow-y: auto !important;\n      @include scrollBar;\n    }\n\n    .react-datepicker__time {\n      background: var(--calendar-surface-title);\n    }\n\n    .react-datepicker__time-list-item {\n      color: var(--calendar-text-icon-default);\n      background: var(--calendar-surface-row);\n      height: unset !important;\n      padding: 10px !important;\n      display: flex;\n      justify-content: flex-start;\n\n      &--selected,\n      &:not(.react-datepicker__time-list-item--disabled):hover {\n        background: var(--calendar-day-selected) !important;\n        color: var(--calendar-text-icon-selected) !important;\n      }\n\n      &.react-datepicker__time-list-item--disabled:hover {\n        background: var(--calendar-surface-row) !important;\n      }\n    }\n  }\n}\n\n.injectedTimes {\n  :global {\n    .react-datepicker__time-list-item {\n      &:not(.react-datepicker__time-list-item--injected) {\n        display: none !important;\n      }\n    }\n  }\n}\n\n.label {\n  display: block;\n  margin-bottom: 4px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  text-transform: uppercase;\n}\n\n.required {\n  &:after {\n    content: '*';\n    font-size: 10px;\n    line-height: 12px;\n    color: var(--inputs-error-stroke);\n    margin-left: 4px;\n  }\n}\n\n.calendarIcon {\n  position: absolute;\n  bottom: 10px;\n  right: 13px;\n}\n\n.helperText {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--inputs-error-stroke);\n  margin-top: 4px;\n  min-height: 11px;\n\n  @media (max-width: 850px) {\n    font-size: 8px;\n    line-height: 8px;\n    margin-top: 2px;\n    min-height: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fieldBlock": `fieldBlock__aRxHk`,
	"labelField": `labelField__lvdT7`,
	"infoIcon": `infoIcon__z0dGO`,
	"datepickerWrapper": `datepickerWrapper__vikza`,
	"datepicker": `datepicker__y9Cqt`,
	"datepickerFilled": `datepickerFilled__KUh6G`,
	"datePickerHeader": `datePickerHeader__GzFx8`,
	"dropdownsContainer": `dropdownsContainer__Ph4fF`,
	"customDropdown": `customDropdown__AMaRp`,
	"customDropdownHeader": `customDropdownHeader__jH77H`,
	"customDropdownIcon": `customDropdownIcon__l5T8b`,
	"customDropdownMenu": `customDropdownMenu__IaRZL`,
	"customDropdownItem": `customDropdownItem__WT_pJ`,
	"prevMonthButton": `prevMonthButton__L4oNE`,
	"nextMonthButton": `nextMonthButton__dhEO5`,
	"buttonDisabled": `buttonDisabled__fDFF0`,
	"injectedTimes": `injectedTimes__xhpoU`,
	"label": `label___lp_b`,
	"required": `required__vS2TB`,
	"calendarIcon": `calendarIcon__lkjfb`,
	"helperText": `helperText__rf2VP`
};
module.exports = ___CSS_LOADER_EXPORT___;
